import { LogService } from 'library/ts/utilities/logger/LogService';
import * as ObjectModule from 'library/ts/utilities/modules/Object';
import * as Type from 'library/ts/utilities/modules/Type';

const logger = LogService.create( { prefixes: [ 'SmartTag:', 'Utilities:', 'API.executeCallback:' ] } );

/**
 * @description Executes page call
 * @param {string} method
 * @param namespace
 * @param params
 * @param {boolean} returnValue
 * @return {any}
 */
export const executeCallback = (
	method: string,
	namespace: any = undefined,
	params: any = undefined,
	returnValue: boolean = false
): void | any | Promise<any> => {
	// sanity check on namespace
	if ( Type.isUndefined( namespace ) ) return;

	// namespace string to object
	if ( Type.isString( namespace ) ) namespace = ObjectModule.getDeepVal( window, namespace );

	// get API function reference on page based on method name
	const apiMethod: ( params: any ) => any = ( Type.isEmpty( namespace ) === false ? ObjectModule.getDeepVal( namespace, String( method ) ) : undefined );

	// filter by method detection results
	switch ( Type.isFunction( apiMethod ) ) {

		case true: // method was found on page
			try {
				switch ( returnValue ) {
					case false:
						apiMethod( params ); // execute API method
						break;
					case true:
						const result = apiMethod( params ); // execute + return API method
						// Check if result is a Promise and wrap it with error handling to prevent unhandled rejections
						if ( Type.isPromise( result ) ) {
							return result.catch( ( error ) => {
								logger.warn( 'method:', method, 'params:', params, 'PROMISE REJECTION:', error );
								return Promise.reject( error ); // Re-throw to allow caller to handle if they want
							} );
						}
						return result;
						break;
				}
			} catch ( error ) {
				logger.warn( 'method:', method, 'params:', params, 'SYNCHRONOUS ERROR:', error );
				// If returnValue is true, return a rejected promise so caller can handle it consistently
				if ( returnValue ) {
					return Promise.reject( error );
				}
			}
			break;

		case false: // method was not found on page...
			switch ( returnValue ) {
				case true:
					logger.warn( 'method:', method, 'was not found on page', 'params:', params );
					return undefined;
					break;
			}
			break;

	}
};